import React from "react" //, { useRef } 
// import { Canvas, useLoader, useThree } from "@react-three/fiber"
// import { Environment, OrbitControls, Html  } from "@react-three/drei"
// import Overlay from "./Overlay"
// import Model from "./Pyramid";
// import { DirectionalLight } from "three";
// import { OrbitControls, TransformControls, ContactShadows, useGLTF, useCursor, Html } from '@react-three/drei'
// import { proxy, useSnapshot } from 'valtio'
import Htmltie from './htmltie';

export const PortfolioPage = ({ children, elementBasis }) => {
  // const caption = useRef()
  // const scroll = useRef(0)

  // const overlay = useRef()
  // const caption = useRef()
  // const scroll = useRef(0)

  return (
    <>
      <Htmltie/>
      {/* <Canvas style={{
        position: "fixed",
        top: 120,
        left: 0,
        zIndex: -99,
      }}
       camera={{position: [0, 5, 5], fov: 50}} 
       dpr={[1,2]}
       shadows 
       raycaster={{ computeOffsets: ({ clientX, clientY }) => ({ offsetX: clientX, offsetY: clientY }) }}>
        <ambientLight intensity={0.1} />
        <hemisphereLight color="#ffffff" groundColor="#b9b9b9" position={[-7, 25, 13]} intensity={0.85} />
        <directionalLight intensity={1} color={"red"} />
        <pointLight position={[10, 10, 10]} />
        <Suspense fallback={null}>
          <Model scroll={scroll}/>
          <ContactShadows rotation-x={Math.PI / 2} position={[0, -35, 0]} opacity={0.25} width={200} height={200} blur={1} far={50} />
        </Suspense>
        <OrbitControls />
      </Canvas> */}
      {/* <Overlay ref={overlay} caption={caption} scroll={scroll} /> */}


      {/* <Canvas */}
        {/* shadows> */}
        {/* // onCreated={(state) => state.events.connect(overlay.current)}
        // raycaster={{ computeOffsets: ({ clientX, clientY }) => ({ offsetX: clientX, offsetY: clientY }) }}>
        // <ambientLight intensity={1} /> */}
      {/* </Canvas> */}
      {/* <Overlay ref={overlay} caption={caption} scroll={scroll} /> */}
    </>
  );
};
